import { useCallback } from "react";

import { useEditorContext } from "../context/editorContext";

export const shouldRoutePackagePriceToSetPackagePrice = (row, fieldName) => {
	const isPackageHeader = !!(row.IsPackageHeader || row.isPackageHeader);
	const isPackagePriceField = fieldName === "QuoteItemPrice" || fieldName === "RecurringAmount";
	const canEditPackagePrice = !!(
		row.OverridePackageDetails || quosal.settings.getValue("enableEditPackagePrice")
	);

	return isPackageHeader && isPackagePriceField && canEditPackagePrice;
};

const getInvoiceGroupingRecid = (row) =>
	row.InvoiceGroupingRecid ?? row.invoiceGroupingRecid ?? 0;

const useDataGridBoilerplateHelpers = (props) => {
	const { tabItem } = props;
	const { isDisabledQuoteActions } = useEditorContext();
	const canModifyProtectedItem = quosal.util.userCanModifyProtectedItem();

	const notEditableFields = {
		priceModifier: "Price Modifier",
		recurringPriceModifier: "Recurring Price Modifier",
		overridePriceModifier: "Override Price Modifier",
		overridePrice: "Override Price",
		basePrice: "Base Price",
		extendedPrice: "Extended Price",
		recurringPrice: "Recurring Price",
		recurringBasePrice: "Recurring Base Price",
		suggestedPrice: "Suggested Price",
		bundlePrice: "Bundle Price",
		recurringSuggestedPrice: "Recurring Suggested Price",
		recurringExtendedSuggestedPrice: "Recurring Extended Suggested Price",
		quantity: "Quantity",
		manufacturerPartNumber: "Manufacturer Part Number",
		extendedSuggestedPrice: "Extended Suggested Price",
		gsaPrice: "Gsa Price",
		bundleQty: "Bundle Qty"
	};

	const isBundleItem = (params) =>
		!(params.colDef.headerName === notEditableFields.priceModifier 
			|| params.colDef.headerName === notEditableFields.recurringPriceModifier 
			|| params.colDef.headerName === notEditableFields.overridePriceModifier 
			|| params.colDef.headerName === notEditableFields.overridePrice 
			|| params.colDef.headerName === notEditableFields.basePrice 
			|| params.colDef.headerName === notEditableFields.extendedPrice 
			|| params.colDef.headerName === notEditableFields.recurringPrice 
			|| params.colDef.headerName === notEditableFields.recurringBasePrice 
			|| params.colDef.headerName === notEditableFields.suggestedPrice 
			|| params.colDef.headerName === notEditableFields.bundlePrice 
			|| params.colDef.headerName === notEditableFields.recurringSuggestedPrice 
			|| params.colDef.headerName === notEditableFields.recurringExtendedSuggestedPrice 
			|| params.colDef.headerName === notEditableFields.extendedSuggestedPrice 
			|| params.colDef.headerName === notEditableFields.gsaPrice 
			|| params.colDef.headerName === notEditableFields.bundleQty
		);

	const isInvoiceGroupItem = (params) =>
		!(params.colDef.headerName === notEditableFields.overridePrice 
			|| params.colDef.headerName === notEditableFields.basePrice 
			|| params.colDef.headerName === notEditableFields.extendedPrice 
			|| params.colDef.headerName === notEditableFields.recurringPrice 
			|| params.colDef.headerName === notEditableFields.recurringBasePrice 
			|| params.colDef.headerName === notEditableFields.suggestedPrice 
			|| params.colDef.headerName === notEditableFields.bundlePrice 
			|| params.colDef.headerName === notEditableFields.recurringSuggestedPrice 
			|| params.colDef.headerName === notEditableFields.recurringExtendedSuggestedPrice 
			|| params.colDef.headerName === notEditableFields.extendedSuggestedPrice 
			|| params.colDef.headerName === notEditableFields.gsaPrice 
			|| params.colDef.headerName === notEditableFields.quantity 
			|| params.colDef.headerName === notEditableFields.manufacturerPartNumber 
			|| params.colDef.headerName === notEditableFields.bundleQty
		);

	const isEditableRowItem = useCallback(
		(params) => {
			if (app.currentQuote.IsLocked && !app.currentQuote.IsArchive && !app.currentQuote.IsTemplate && app.currentQuote.IsRequestQuote && app.settings.user.AllowSourceCostUpdate) {
				return true;
			}
			if (isDisabledQuoteActions || (params.row.IsProtectedItem && !canModifyProtectedItem)) {
				return false;
			}

			const fieldName = params.colDef?.field;
			const isPackageHeader = !!(params.row.IsPackageHeader || params.row.isPackageHeader);
			const invoiceGroupingRecid = getInvoiceGroupingRecid(params.row);

			if (isPackageHeader && !invoiceGroupingRecid) {
				if (fieldName === "QuoteItemPrice" || fieldName === "RecurringAmount") {
					return shouldRoutePackagePriceToSetPackagePrice(params.row, fieldName);
				}
			}

			const isBundle = isBundleItem(params);
			const isInvoiceGroup = isInvoiceGroupItem(params);
			if (params.row.TaxCode === "PACKAGE" && invoiceGroupingRecid == 0) {
				return isBundle;
			}

			if (params.row.IsPackageItem && params.colDef.headerName === notEditableFields.quantity) {
				return false;
			}

			if (params.row.TaxCode === "PACKAGE" && invoiceGroupingRecid > 0) {
				return isInvoiceGroup;
			}

			if (!params.row.IsPackageItem && params.colDef.headerName === notEditableFields.bundleQty) {
				return false;
			}

			return true;
		},
		[isDisabledQuoteActions, canModifyProtectedItem]
	);

	const handleEdit = useCallback(
		(row) => {
			app.currentModule.loadSubModule("product.edit", {
				container: "quoteModule",
				query: `itemid=${row.idQuoteItems}&idquotetabs=${row.idQuoteTabs}`
			});

			sessionStorage.setItem("cpq_open_tab", tabItem?.IdQuoteTabs);
		},
		[tabItem?.IdQuoteTabs]
	);

	return {
		isEditableRowItem,
		handleEdit
	};
};

export default useDataGridBoilerplateHelpers;
